module.exports = __webpack_public_path__ + "static/video_sp_jp-54ca65acb55d1f99718b46d16395f23f.mp4";